/** Focus Trap - Import */
import { createFocusTrap } from "focus-trap";

console.log("Accessibility widget loaded.");

/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(";").shift();
}

/** Block / Layout Functions */

/* Accessibility Functions */
function accessibilityInit() {
	const togglePanelButton = document.getElementById("accessibilityPanelToggle");
	const accessibilityAid = document.getElementById("accessibilityAid");
	const accessibilityPanel = document.getElementById("accessibilityPanel");
	const fontSizeButton = document.getElementById("fontSize");
	const highContrastButton = document.getElementById("highContrast");
	const reduceMotionButton = document.getElementById("reduceMotion");
	const html = document.querySelector("html");
	const videos = document.querySelectorAll("video[autoplay]");
	const accessibilityFocusTrap = createFocusTrap(accessibilityAid);

	function togglePanel() {
		if (accessibilityAid.classList.contains("accessibility-aid--active")) {
			accessibilityAid.classList.remove("accessibility-aid--active");
			togglePanelButton.setAttribute("aria-expanded", "false");
			accessibilityPanel.setAttribute("aria-hidden", "true");
			accessibilityPanel.style.display = "none";
			togglePanelButton.focus();
			accessibilityFocusTrap.deactivate();
		} else {
			accessibilityPanel.style.display = "flex";
			togglePanelButton.setAttribute("aria-expanded", "true");
			accessibilityPanel.setAttribute("aria-hidden", "false");
			accessibilityFocusTrap.activate();
			accessibilityAid.classList.add("accessibility-aid--active");

			setTimeout(() => {
				accessibilityPanel.focus();
			}, 25);
		}
	}

	togglePanelButton.addEventListener("click", togglePanel);

	// individual button actions
	if (fontSizeButton) {
		if (getCookie("font-size") === "bigger") {
			fontSizeButton.classList.add("accessibility-option--active");
			document.documentElement.style.setProperty("font-size", "120%");
		}

		fontSizeButton.addEventListener("click", function () {
			const fontSizeCookie = getCookie("font-size");
			if (fontSizeCookie !== "bigger") {
				document.cookie = `font-size=bigger;max-age=${60 * 60 * 24 * 7};path=/`;
				fontSizeButton.classList.add("accessibility-option--active");
				document.documentElement.style.setProperty("font-size", "120%");
			} else {
				document.cookie = `font-size=initial;max-age=${
					60 * 60 * 24 * 7
				};path=/`;
				fontSizeButton.classList.remove("accessibility-option--active");
				document.documentElement.style.setProperty("font-size", "100%");
			}
		});
	}
	if (highContrastButton) {
		if (getCookie("high-contrast") === "true") {
			highContrastButton.classList.add("accessibility-option--active");
		}

		highContrastButton.addEventListener("click", function () {
			const highContrastCookie = getCookie("high-contrast");
			if (highContrastCookie !== "true") {
				document.cookie = `high-contrast=true;max-age=${
					60 * 60 * 24 * 7
				};path=/`;
				highContrastButton.classList.add("accessibility-option--active");
				html.classList.add("high-contrast");
			} else {
				document.cookie = `high-contrast=initial;max-age=${
					60 * 60 * 24 * 7
				};path=/`;
				highContrastButton.classList.remove("accessibility-option--active");
				html.classList.remove("high-contrast");
			}
		});
	}
	if (reduceMotionButton) {
		if (getCookie("reduce-motion") === "true") {
			reduceMotionButton.classList.add("accessibility-option--active");
		}

		reduceMotionButton.addEventListener("click", function () {
			const reduceMotionCookie = getCookie("reduce-motion");
			if (reduceMotionCookie !== "true") {
				document.cookie = `reduce-motion=true;max-age=${
					60 * 60 * 24 * 7
				};path=/`;
				reduceMotionButton.classList.add("accessibility-option--active");
				html.classList.add("reduce-motion");
				// gsap.globalTimeline.pause();
				videos.forEach((video) => video.pause());
			} else {
				document.cookie = `reduce-motion=initial;max-age=${
					60 * 60 * 24 * 7
				};path=/`;
				reduceMotionButton.classList.remove("accessibility-option--active");
				html.classList.remove("reduce-motion");
				// gsap.globalTimeline.play();
				videos.forEach((video) => video.play());
			}
		});
	}
}

/* Initialize Everything */
document.addEventListener("DOMContentLoaded", function () {
	/* Accessibility Cookie Fixes */
	if (getCookie("reduce-motion") === "true") {
		const videos = document.querySelectorAll("video[autoplay]");
		videos.forEach((video) => video.pause());
	}

	if (getCookie("high-contrast") === "true") {
		const html = document.querySelector("html");
		html.classList.add("high-contrast");
	}

	if (getCookie("reduce-motion") === "true") {
		const html = document.querySelector("html");
		html.classList.add("reduce-motion");
	}

	/* Accessibility Panel */
	if (document.getElementById("accessibilityPanelToggle")) {
		accessibilityInit();
	}
});
